import {
  getPage,
  getClientPage,
  getClientTendaysdata,
} from '@/api/operationtrendserv'

export default {
  state: {
    state_OperationTrend_GetPageResult: null,
    state_OperationTrend_GetClientPageResult: null,
    state_OperationTrend_GetClientTendaysdataResult: null,
  },
  mutations: {
    SET_OPERATIONTREND_GETPAGE_RESULT: (state, rst) => {
      state.state_OperationTrend_GetPageResult = rst;
    },
    SET_OPERATIONTREND_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_OperationTrend_GetClientPageResult = rst;
    },
    SET_OPERATIONTREND_GETCLIENTTENDAYSDATA_RESULT: (state, rst) => {
      state.state_OperationTrend_GetClientTendaysdataResult = rst;
    },
  },
  actions: {
    OperationTrendServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OPERATIONTREND_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OPERATIONTREND_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OperationTrendServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OPERATIONTREND_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OPERATIONTREND_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OperationTrendServ_GetClientTendaysdata({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientTendaysdata(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OPERATIONTREND_GETCLIENTTENDAYSDATA_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OPERATIONTREND_GETCLIENTTENDAYSDATA_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_OperationTrend_GetPageResult: state => {
      return state.state_OperationTrend_GetPageResult;
    },
    get_OperationTrend_GetClientPageResult: state => {
      return state.state_OperationTrend_GetClientPageResult;
    },
    get_OperationTrend_GetClientTendaysdataResult: state => {
      return state.state_OperationTrend_GetClientTendaysdataResult;
    },
  }
}